import { useMutation } from 'react-query';

import {
  InitConfirmActionViaEmailCodeParams,
  initConfirmActionViaEmailCode,
} from '@utils/backend-api/userConfirmActionViaEmailCode';

export default function useInitConfirmActionViaEmailCode() {
  const { mutate, mutateAsync, data, isLoading, isError, error } = useMutation(
    (values: InitConfirmActionViaEmailCodeParams) => initConfirmActionViaEmailCode(values),
    {
      onSuccess: () => {
        console.log('Sent Email');
      },
    }
  );

  return {
    mutate,
    mutateAsync,
    data,
    isLoading,
    isError,
    error,
  };
}
